import { render, staticRenderFns } from "./_countries-regions.vue?vue&type=template&id=02015940&scoped=true"
import script from "./_countries-regions.vue?vue&type=script&lang=js"
export * from "./_countries-regions.vue?vue&type=script&lang=js"
import style0 from "./_countries-regions.vue?vue&type=style&index=0&id=02015940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02015940",
  null
  
)

export default component.exports